import * as React from 'react';

function CopyIconComponent(props: any) {
  return (
    <svg
      height="100%"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2802_8330)">
        <path
          d="M11.75 1.75H6.75C5.92157 1.75 5.25 2.42157 5.25 3.25V10.25C5.25 11.0784 5.92157 11.75 6.75 11.75H11.75C12.5784 11.75 13.25 11.0784 13.25 10.25V3.25C13.25 2.42157 12.5784 1.75 11.75 1.75Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.75 14.25H4.25C3.42157 14.25 2.75 13.5784 2.75 12.75V4.25"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2802_8330">
          <rect width="16" height="16" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default CopyIconComponent;
